import React, { useEffect } from 'react';

const Modal = ({ 
  isOpen, 
  onClose, 
  children, 
  showCloseButton = true,
  closeOnBackdropClick = true,
  closeOnEscape = true,
  preventClose = false
}) => {
  useEffect(() => {
    if (!isOpen) return;

    // ESCキーでの閉じる機能を条件付きで有効化
    const createEscapeHandler = (onClose) => (event) => {
      if (event.key !== 'Escape') return;
      if (preventClose || !closeOnEscape) return;
      onClose();
    };

    const handleEscape = createEscapeHandler(onClose);
    
    // bodyのスクロールを無効化
    document.body.style.overflow = 'hidden';
    
    // ESCキー機能が有効な場合のみイベントリスナーを追加
    if (closeOnEscape && !preventClose) {
      document.addEventListener('keydown', handleEscape);
    }

    // クリーンアップ
    return () => {
      document.body.style.overflow = 'unset';
      if (closeOnEscape && !preventClose) {
        document.removeEventListener('keydown', handleEscape);
      }
    };
  }, [isOpen, onClose, closeOnEscape, preventClose]);

  // 条件による早期リターンはuseEffectの後で
  if (!isOpen) return null;

  // 背景クリックのハンドラー
  const handleBackdropClick = (e) => {
    if (preventClose || !closeOnBackdropClick) return;
    onClose();
  };

  // 閉じるボタンのハンドラー
  const handleCloseButtonClick = () => {
    if (preventClose) return;
    onClose();
  };

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    },
    modal: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '500px',
      width: '90%',
      maxHeight: '80vh',
      overflow: 'auto',
      position: 'relative',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: preventClose ? 'not-allowed' : 'pointer',
      color: preventClose ? '#ccc' : '#666',
      padding: '5px',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: showCloseButton ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: preventClose ? 0.5 : 1
    }
  };

  return (
    <div style={styles.overlay} onClick={handleBackdropClick}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {showCloseButton && (
          <button 
            style={styles.closeButton} 
            onClick={handleCloseButtonClick}
            aria-label="モーダルを閉じる"
            disabled={preventClose}
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;